import { isOpenPartnerCancelPaymentModal } from "@/atoms/order/is-open-partner-cancel-payment-modal";
import { orderDetailState } from "@/atoms/order/order-detail-state";
import { toastState } from "@/atoms/system/toast-state";
import { ButtonColor } from "@/common/enum/button-color";
import { canCancel } from "@/page/order/PartnerOrderDetailPage";
import { orderService } from "@/services/order-service2";
import { Button, Modal } from "flowbite-react";
import React from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { Body14Regular } from "../typography/Body14Regular";
import { H4 } from "../typography/H4";
import { H5 } from "../typography/H5";

interface Props {}

export const PartnerCancelPaymentModal: React.FC<Props> = ({}) => {
  const [modal, setModal] = useRecoilState(isOpenPartnerCancelPaymentModal);
  const [orderDetail, setOrderDetail] = useRecoilState(orderDetailState);
  const setToast = useSetRecoilState(toastState);

  if (!orderDetail) {
    return null;
  }

  if (!modal) {
    return null;
  }

  const closeModal = () => {
    setModal(false);
  };

  const handleCancelButtonClick = async () => {
    try {
      const response = await orderService.cancel(orderDetail.id);
      if (!response.ok) {
        return;
      }
      const getByIdResponse = await orderService.getById(orderDetail.id);
      if (!getByIdResponse.ok) {
        return;
      }
      setOrderDetail(getByIdResponse.data);
      setToast({
        show: true,
        messages: [`발주 취소가 완료되었습니다.`],
      });
      closeModal();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal size="2xl" show={true} onClose={closeModal}>
      <Modal.Header className="p-[24px] h-[76px]">
        <H4>발주 취소하기</H4>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col justify-center items-center">
          <div className="box-border border border-semantic-divider rounded-[8px] w-[572px] h-[90px] bg-grayscale-contrast-2 flex justify-center flex-col py-[16px] px-[12px] gap-[12px]">
            <H5 className="text-semantic-text-heading">알아두세요!</H5>
            <div className="flex flex-col">
              <Body14Regular className="text-semantic-text-body">
                결제가 완료된 발주건을 취소할 경우 접수 이후 영업일 기준 7일
                이내로 정상 환불 처리됩니다.
              </Body14Regular>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="w-full"
          disabled={!canCancel(orderDetail)}
          color={canCancel(orderDetail) ? ButtonColor.PRIMARY : ""}
          onClick={handleCancelButtonClick}
        >
          발주 취소하기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
